import { render } from "./TinyEditor.vue?vue&type=template&id=50389016&scoped=true"
import script from "./TinyEditor.vue?vue&type=script&lang=js"
export * from "./TinyEditor.vue?vue&type=script&lang=js"

import "./TinyEditor.vue?vue&type=style&index=0&id=50389016&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/NEW-Master-integrated-sugang-admin-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50389016"]])

export default __exports__